export default "__VITE_ASSET__DnULGDsK__"